import { render, staticRenderFns } from "./allrecords.vue?vue&type=template&id=405e1b44"
import script from "./allrecords.vue?vue&type=script&lang=js"
export * from "./allrecords.vue?vue&type=script&lang=js"
import style0 from "./allrecords.vue?vue&type=style&index=0&id=405e1b44&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports